import React from 'react';
import { Header, Rec } from '../../../component';
import wandu from '../../../service/wandu';

    export default class Recommend extends React.Component {

    state = {
        rec: [], 
    }

    componentDidUpdate(prevProps) {
        if (!this.props.type) {
            return; 
        } 
        if (this.props.novel_id !== prevProps.novel_id
                || this.props.type !== prevProps.type) {
            this._load(); 
        }
    }

    _load = () => {
        let page = '';
        switch (Number(this.props.type)) {
        case 1: 
            page = 'book_detail';
            break;
        case 2:
            page = 'comic_book_detail';
            break;
        default:
            return;
        }
        wandu.book_rec({
            novel_id: this.props.novel_id, 
            page,
        }).then(res => {
            this.setState({rec: res.rec});
        }).catch(e => {
            console.log(e);
        }); 
    }

    render() {
        const blocks = this.state.rec.map(item => {
            switch(item.template) {
            case 1: 
                // 当作者的作品超过一本时用轮播图展示（最多5个）
                if(item.items.length!==1){
                    return (
                        <div style={{position: 'relative'}}>
                            <Header title={item.title} em />
                            <Rec.SlideWorks data={item.items.map(item => ({
                                link: item.link,
                                name: item.name, 
                                pic: item.cover,
                                is_done: Number(item.is_done) ? '已完结' : '未完结',
                                cata: item.tag_name,
                                brief: item.abs,
                            }))}/>
                        </div>
                    );
                }
                else{
                    return (
                        <Rec.ListRec
                            column={1}
                            width={212}
                            template='brief_5'
                            header={<Header title={item.title} em />}
                            data={item.items.map(book => ({
                                link:book.link,
                                novel_id: book.id,  
                                name: book.name,  
                                pic: book.cover,
                                is_done: Number(book.is_done),
                                cata: book.tag_name,
                                brief: book.abs,
                            }))}
                        />
                    )
                }
            case 2:
                return (
                    <Rec.ListRec
                        template='brief_6'
                        column={2}
                        width={96}
                        gap={20}
                        header={<Header title={item.title} em />}
                        data={item.items.map(book => ({
                            novel_id: book.id,  
                            name: book.name,  
                            pic: book.cover,
                            reason: book.reason,
                        }))}
                    />
                );
            case 6:
                return (
                    <Rec.ListRec
                        template='brief_7'
                        column={2}
                        width={96}
                        gap={20}
                        header={<Header title={item.title} em />}
                        data={item.items.slice(0, 2).map(book => ({
                            novel_id: book.id,  
                            name: book.name,  
                            pic: book.cover,
                            desc: book.desc,
                        }))}
                    />
                );
            default:
                return null;
            } 
        }).filter(item => item);
        return (
        <div> 
        { blocks.map((item, idx) => (
            <div key={idx} className="block" style={{
                marginBottom: '20px',
            }}>{item}</div>
        ))}
        </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/layout/book/detail/rec.js